import React from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import ProfilePicture from 'components/common/ProfilePicture'
import Tooltip from 'components/common/Tooltip'
import useRolePermissions from 'hooks/useRolePermissions'
import { summarizeViewers } from 'utils/presenceUtils'

const useStyles = makeStyles({
  container: { display: 'flex', alignItems: 'center' },
  overflow: { fontSize: 11, fontWeight: 600, color: 'var(--text-color-11)', marginLeft: 2 }
})

const PatientPresenceMarker = ({ patientId }) => {
  const classes = useStyles()
  const { permissions } = useRolePermissions()
  const viewers = useSelector(state => Object.values(state.presenceReducer.byPatientId[patientId] || {}), shallowEqual)

  if (!permissions.hiPresence || !viewers.length) {
    return null
  }

  const { primary, overflowCount, tooltip } = summarizeViewers(viewers)
  if (!primary) {
    return null
  }

  return (
    <Tooltip value={tooltip} variant="dark" arrow placement="top">
      <div className={classes.container}>
        <ProfilePicture photo={primary.photo} name={primary.name} size="xsmall" />
        {overflowCount > 0 && <span className={classes.overflow}>+{overflowCount}</span>}
      </div>
    </Tooltip>
  )
}

export default PatientPresenceMarker
